<template>
  <main class="director-profile" style="background: #005d79 !important;">
    <SimpleHeader route="/main">
      <template v-slot:title>
        <span>
       {{$ml.get('קביעת יעדים וניהול הפסקות')}}
        </span>
      </template>
      <span slot="additional">
        <sidebar-toggler />
        <router-link :to="'/'" class="home-anchor" style="color: white;">
          <svg
                    width="22"
                    height="20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style="position:absolute; top: 4px; right: 24px;"
                  >
                    <path
                      d="M10.3312 0.926701L10.2632 0.863573L10.1951 0.926701L0.931976 9.52313L0.85877 9.59106L0.926614 9.66436L1.78441 10.591L1.85245 10.6645L1.92585 10.5964L2.59093 9.9786V17V17.1H2.69093H9.00112H9.10112V17V10.7907H11.4252V17V17.1H11.5252H17.8354H17.9354V17V9.9786L18.6005 10.5964L18.6739 10.6645L18.7419 10.591L19.5997 9.66436L19.6675 9.59106L19.5943 9.52313L10.3312 0.926701ZM16.4733 8.6246V15.6381H12.8872V9.42883V9.32883H12.7872H7.73908H7.63908V9.42883V15.6381H4.05297V8.6246L10.2632 2.85187L16.4733 8.6246Z"
                      fill="white"
                      stroke="white"
                      stroke-width="0.2"
                    />
                  </svg>
        </router-link>
      </span>
    </SimpleHeader>
    <app-loading class="sm-cont">
      <template>


        <div class="director-links">
          <div class="background"></div>
          <router-link class="link-element" :to="{name: 'director-goals'}">
            <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20.24 0C9.07984 0 0 9.07984 0 20.24C0 31.4002 9.07984 40.48 20.24 40.48C31.4002 40.48 40.48 31.4002 40.48 20.24C40.48 16.1946 39.2829 12.4251 37.2298 9.25891L36.4444 10.0444L35.9425 10.5463C37.6919 13.3684 38.72 16.6822 38.72 20.24C38.72 30.4304 30.4304 38.72 20.24 38.72C10.0496 38.72 1.76 30.4304 1.76 20.24C1.76 10.0496 10.0496 1.76 20.24 1.76C24.5637 1.76 28.5299 3.27135 31.68 5.76984V7.55563L29.5367 9.69891C27.0548 7.50411 23.8057 6.16 20.24 6.16C12.4766 6.16 6.16 12.4766 6.16 20.24C6.16 28.0034 12.4766 34.32 20.24 34.32C28.0034 34.32 34.32 28.0034 34.32 20.24C34.32 17.3105 33.4185 14.5875 31.8811 12.332L30.6058 13.6073C31.836 15.5249 32.56 17.7971 32.56 20.24C32.56 27.0336 27.0336 32.56 20.24 32.56C13.4464 32.56 7.92 27.0336 7.92 20.24C7.92 13.4464 13.4464 7.92 20.24 7.92C23.3211 7.92 26.1317 9.06553 28.2923 10.9433L25.1711 14.0645C23.8171 12.9785 22.107 12.32 20.24 12.32C15.8734 12.32 12.32 15.8734 12.32 20.24C12.32 24.6066 15.8734 28.16 20.24 28.16C24.6066 28.16 28.16 24.6066 28.16 20.24C28.16 19.0194 27.8742 17.8683 27.3797 16.8352L26.0373 18.1758C26.2679 18.8217 26.4 19.5158 26.4 20.24C26.4 23.6368 23.6368 26.4 20.24 26.4C16.8432 26.4 14.08 23.6368 14.08 20.24C14.08 16.8432 16.8432 14.08 20.24 14.08C21.6216 14.08 22.8933 14.5429 23.9216 15.3141L20.6938 18.5419C20.5458 18.5016 20.3933 18.4808 20.24 18.48C19.7732 18.48 19.3256 18.6654 18.9955 18.9955C18.6654 19.3256 18.48 19.7732 18.48 20.24C18.48 20.7068 18.6654 21.1544 18.9955 21.4845C19.3256 21.8146 19.7732 22 20.24 22C20.7068 22 21.1544 21.8146 21.4845 21.4845C21.8146 21.1544 22 20.7068 22 20.24C21.9999 20.0862 21.9797 19.9331 21.9398 19.7845L32.9244 8.8H35.2L39.6 4.4H36.08V0.88L32.6717 4.28828C29.2379 1.60542 24.9254 0 20.24 0Z" fill="#06364B"/>
            </svg>

            <span>{{$ml.get('קביעת יעדים')}} </span>
          </router-link>

          <router-link class="link-element" :to="{name: 'director-reports'}">
            <svg width="30" height="38" viewBox="0 0 30 38" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 0V38H11.6923V35.0769H2.92308V2.92308H17.5385V11.6923H26.3077V20.4615H29.2308V9.6256L19.6052 0H0ZM20.4615 4.98978L24.241 8.76923H20.4615V4.98978ZM26.3077 23.3846V38H29.2308V23.3846H26.3077ZM20.4615 27.7692V38H23.3846V27.7692H20.4615ZM14.6154 32.1538V38H17.5385V32.1538H14.6154Z" fill="#00465B"/>
            </svg>

            <span>{{$ml.get('דו“ח התקדמות בכיתות')}}</span>
          </router-link>

          <router-link v-if="false" class="link-element" :to="{name: 'teacher-inventing-games'}">
            <svg width="37" height="48" viewBox="0 0 37 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18.5009 0C15.6733 0 13.3599 2.31342 13.3599 5.14092C13.3599 7.96843 15.6733 10.2818 18.5009 10.2818C21.3284 10.2818 23.6418 7.96843 23.6418 5.14092C23.6418 2.31342 21.3284 0 18.5009 0ZM18.5009 2.05637C20.2158 2.05637 21.5854 3.42594 21.5854 5.14092C21.5854 6.8559 20.2158 8.22548 18.5009 8.22548C16.7859 8.22548 15.4163 6.8559 15.4163 5.14092C15.4163 3.42594 16.7859 2.05637 18.5009 2.05637ZM3.07808 7.22942C2.69251 7.22541 2.31095 7.28164 1.9535 7.42221C1.21851 7.7154 0.583926 8.28572 0.250569 9.06088C-0.420162 10.6152 0.302781 12.4426 1.85711 13.1094C1.86916 13.1214 1.87719 13.1294 1.88924 13.1415L13.3599 17.5113V22.9092L4.07413 32.195C2.74874 33.5204 2.74874 35.7214 4.07413 37.0468C5.39953 38.3722 7.60048 38.3722 8.92588 37.0468L18.5009 27.4718L28.0758 37.0468C29.4012 38.3722 31.6022 38.3722 32.9276 37.0468C34.253 35.7214 34.253 33.5204 32.9276 32.195L23.6418 22.9092V17.5113L35.1125 13.1415C35.1245 13.1294 35.1325 13.1214 35.1446 13.1094C36.6989 12.4426 37.4178 10.6152 36.7511 9.06088C36.0925 7.53065 34.3052 6.83181 32.7669 7.45434V7.42221L32.7027 7.45434L22.3887 11.31H14.613L4.29905 7.45434L4.23479 7.42221V7.45434C3.85725 7.30172 3.46365 7.23344 3.07808 7.22942ZM3.07808 9.25366C3.21463 9.25768 3.36324 9.29383 3.49578 9.35006C3.50783 9.35006 3.51586 9.35006 3.52791 9.35006L14.0668 13.3021C14.1793 13.3423 14.2998 13.3664 14.4202 13.3664H22.5815C22.7019 13.3664 22.8224 13.3423 22.9349 13.3021L33.4738 9.35006C33.4858 9.35006 33.4939 9.35006 33.5059 9.35006C34.0361 9.12113 34.6265 9.32998 34.8554 9.86415C35.0803 10.3903 34.8875 10.9767 34.3735 11.2136C34.3654 11.2177 34.3494 11.2096 34.3413 11.2136L22.2602 15.8405C21.8545 15.9891 21.5854 16.3746 21.5854 16.8044V23.3591C21.5894 23.6242 21.6898 23.8772 21.8746 24.066L31.4817 33.6731C32.0239 34.2153 32.0239 35.0587 31.4817 35.6009C30.9395 36.1431 30.096 36.1431 29.5538 35.6009L19.2399 25.2869C19.0471 25.0861 18.778 24.9736 18.5009 24.9736C18.2237 24.9736 17.9546 25.0861 17.7618 25.2869L7.44786 35.6009C6.90566 36.1431 6.06222 36.1431 5.52002 35.6009C4.97781 35.0587 4.97781 34.2153 5.52002 33.6731L15.1271 24.066C15.3119 23.8772 15.4123 23.6242 15.4163 23.3591V16.8044C15.4163 16.3746 15.1472 15.9891 14.7415 15.8405L2.66038 11.2136C2.65234 11.2096 2.63628 11.2177 2.62825 11.2136C2.11415 10.9767 1.92137 10.3863 2.14628 9.86415C2.26276 9.59907 2.45153 9.41432 2.69251 9.31793C2.813 9.26973 2.94152 9.24965 3.07808 9.25366ZM18.5009 38.0428C14.9946 38.0428 12.0426 38.8782 12.0426 38.8782C11.4923 39.0389 11.175 39.6132 11.3357 40.1635C11.4963 40.7137 12.0707 41.031 12.6209 40.8703C12.6209 40.8703 15.3239 40.0992 18.5009 40.0992C21.6778 40.0992 24.3808 40.8703 24.3808 40.8703C24.931 41.031 25.5054 40.7137 25.666 40.1635C25.8267 39.6132 25.5094 39.0389 24.9591 38.8782C24.9591 38.8782 22.0071 38.0428 18.5009 38.0428ZM18.5009 42.1556C10.432 42.1556 3.65643 45.3365 3.65643 45.3365C3.14234 45.5855 2.92546 46.2041 3.17447 46.7182C3.42348 47.2322 4.042 47.4491 4.55609 47.2001C4.55609 47.2001 10.9742 44.212 18.5009 44.212C26.0275 44.212 32.4456 47.2001 32.4456 47.2001C32.9597 47.4491 33.5782 47.2322 33.8272 46.7182C34.0762 46.2041 33.8594 45.5855 33.3453 45.3365C33.3453 45.3365 26.5697 42.1556 18.5009 42.1556Z" fill="#06364B"/>
            </svg>

            <span>{{$ml.get('ניהול ההפסקות')}}</span>
          </router-link>
        </div>
      <div class="router-links-wrapper">
        <div class="row">
          <router-link :to="{name: 'teacher-inventing-games'}" class="solo red " >
            {{$ml.get('קורס המצאת משחקים')}}
          </router-link>
        </div>
        <div class="row">
          <router-link :to="{name: 'funkit'}" class="solo orange" >
            {{$ml.get('ערכות משחקים')}}
          </router-link>
        </div>
        <div class="row">
          <router-link :to="{name: 'workshop'}" class="solo yellow" >
            {{$ml.get('סדנאות')}}
          </router-link>
        </div>


      </div>
        <TeacherTutorial />
      </template>
    </app-loading>
  </main>
</template>

<script>

import SimpleHeader from "@/components/SimpleHeader.vue";
import SidebarToggler from "@/components/SidebarToggler.vue";
import TeacherProfileRadio from "@/components/teacher/TeacherProfileRadio.vue";
import TeacherLinkTo from "@/components/teacher/TeacherLinkTo";
import TeacherTutorial from "@/components/modals/modal/TeacherTutorial";

export default {
  data() {
    return {
      index: 0,
      popup_showed: false,
      radio: '',
      loading: {
        next: false,
        sync: false
      },
    };
  },
  components: {

    // GiftLine,
    SimpleHeader,
    SidebarToggler,
    TeacherProfileRadio,
    TeacherLinkTo,
    TeacherTutorial,
  },
  computed: {
    link() {
      return this.$store.getters['tutorials/isUsed']('teacherTutorial') ? 'teacher-educational-classes' : 'teacher-tutorials';
    }
  },


  methods: {
    openTutorial(){
      this.$store.commit('modals/teacher-tutorial/open');
    }
  },
  created() {

  },
};
</script>

<style lang="scss" scoped>

.director-profile {
  background: rgba(0, 93, 121, 0.91);
  padding-bottom: 0 !important;
  display: flex;
  flex-direction: column;


  .app-loading {
    flex-grow: 1;
    min-height: 450px;
    @media screen and (min-width: 600px) {
      border-left:2px solid #005D79;
      border-right:2px solid #005D79;
      border-radius: 3px;
    }
    .director-links {
      padding: 50px 10px 50px 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      flex-grow: 1;
      position: relative;
      // background-image: url("../../assets/img/main-page/method-draw-image.svg");
      width: 100%;
      height: 100%;
      /*.background{*/
      /*  top: 0;*/
      /*  background-image: url("../../assets/img/director-bg.png");*/
      /*  width: 100%;*/
      /*  height: 100%;*/
      /*  position: absolute;*/
      /*  z-index: 0;*/
      /*}*/
      .link-element {
        margin: 5px auto;
        padding: 10px 20px;
        background: #FFFFFF;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        border-radius: 7px;
        width: 320px;
        min-height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        @media screen and (max-width: 340px){
          width: 100%;
        }
        span {
          font-style: italic;
          font-weight: bold;
          font-size: 21px;
          text-align: center;
          color: #06364B;
        }

        svg {

        }
      }
    }

    .footer {
      width: 100%;

      .treatment {
        height: 80px;
      }

      .report {
        height: 80px;
      }
    }
    .router-links-wrapper{
      width: 100%;
      .row{
        width: 100%;
        display: flex;
        flex-direction: row;
        font-size: 18px;
        line-height: 25px;
        text-align: center;
        font-weight: bold;
        .solo{
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          background: #00465B;
          height: 60px;
          font-weight: bold;
          font-size: 18px;
          color: #00465B;
          &.orange{
            background: #FF984D;
          }
          &.yellow{
            background: #FFC700;
          }
          &.red{
            background: #FF7384;
          }
        }
        .separate{
          height: 60px;
          width: 50%;
          font-weight: bold;
          color: #00465B;
          display: flex;
          align-items: center;
          justify-content: center;

        }
      }
    }
  }
}
</style>
